import { Checkbox, FormControlLabel, Typography } from '@mui/material';

export const SmallCheckBox = ({ checked, onChange, label, disabled }) => {
  return (
    <FormControlLabel
      sx={{ margin: '0px' }}
      disabled={disabled}
      control={
        <Checkbox
          checked={checked}
          size='small'
          sx={{
            padding: '0 10px',
          }}
          onChange={onChange}
        />
      }
      label={<Typography variant='body2'>{label}</Typography>}
    />
  );
};
